import React from "react";
import "./loader.css";

export const Loader =()=>(
    <div className="loading-wrap">
        <div className="loading-default">
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
    </div>
)